import { CheckboxOptCustom } from '../checkbox-opt-custom';
import { ToppingsByParentId } from '../toppings-by-parentId';

import { formatCurrency } from 'utils/CurrencyUtils';

import { ATTRIBUTE_NAME_OP_ID } from 'features/order/substitution-flow/domain';
import makeClasses from './ProductOfOrder.style';

import type { ProductInOrderDetail } from 'shared/domain';

export function ProductOfOrder(props: Props) {
  const { product } = props;

  const _classes = makeClasses();

  return (
    <article
      key={product.orderProductId}
      className={_classes.article}
      data-product-id={product.id}
      {...{ [ATTRIBUTE_NAME_OP_ID]: product.orderProductId }}
    >
      <section aria-label='product' className={_classes.product}>
        <CheckboxOptCustom
          fullWidth={true}
          value='product'
          name={product.orderProductId.toString()}
          label={
            <>
              <header className={_classes.productHeader}>
                <h2>
                  <span>{`${product.units}x `}</span>
                  {product.name}
                </h2>
                <span>{formatCurrency(product.price.totalReal)}</span>
              </header>
              <p className={_classes.productDescription}>
                {product.description}
              </p>
            </>
          }
        />
      </section>

      {product.toppings.length > 0 && (
        <section aria-label='toppings'>
          <ToppingsByParentId toppings={product.toppings} />
        </section>
      )}
    </article>
  );
}

interface Props {
  product: ProductInOrderDetail;
}
